import { FEATURE_FLAGS } from 'dashboard/featureFlags';
import { INSTALLATION_TYPES } from 'dashboard/constants/installationTypes';
import {
  AILAB_PERMISSIONS,
  LEGACY_AGENT_ONLY_PERMISSIONS,
} from 'dashboard/constants/permissions.js';
import { frontendURL } from '../../../helper/URLHelper';
import AilabWrapper from './AilabWrapper.vue';
import AssistantIndex from './assistants/Index.vue';
import AssistantEdit from './assistants/Edit.vue';
// import AssistantSettings from './assistants/settings/Settings.vue';
import AssistantInboxesIndex from './assistants/inboxes/Index.vue';
import AssistantGuardrailsIndex from './assistants/guardrails/Index.vue';
import AssistantGuidelinesIndex from './assistants/guidelines/Index.vue';
import AssistantScenariosIndex from './assistants/scenarios/Index.vue';
import DocumentsIndex from './documents/Index.vue';
import ResponsesIndex from './responses/Index.vue';
import ProductInfoIndex from './productInfo/Index.vue';
import AssistantV2Index from './assistantV2/Index.vue';
import AICloserIndex from './aiCloser/Index.vue';
import AIGamerIndex from './aiGamer/Index.vue';

const ailabRoutePermissions = {
  anyOf: [
    'administrator',
    LEGACY_AGENT_ONLY_PERMISSIONS,
    AILAB_PERMISSIONS,
  ],
};

export const routes = [
  {
    path: frontendURL('accounts/:accountId/ailab/assistants'),
    component: AilabWrapper,
    meta: {
      permissions: ailabRoutePermissions,
      featureFlag: FEATURE_FLAGS.CAPTAIN,
      installationTypes: [
        INSTALLATION_TYPES.CLOUD,
        INSTALLATION_TYPES.ENTERPRISE,
      ],
    },
    children: [
      { path: '', name: 'ailab_assistants_index', component: AssistantIndex },
    ],
  },
  {
    path: frontendURL('accounts/:accountId/ailab/assistants/:assistantId'),
    component: AilabWrapper,
    meta: {
      permissions: ailabRoutePermissions,
      featureFlag: FEATURE_FLAGS.CAPTAIN,
      installationTypes: [
        INSTALLATION_TYPES.CLOUD,
        INSTALLATION_TYPES.ENTERPRISE,
      ],
    },
    children: [
      { path: '', name: 'ailab_assistants_edit', component: AssistantEdit },
    ],
  },
  {
    path: frontendURL(
      'accounts/:accountId/ailab/assistants/:assistantId/inboxes'
    ),
    component: AilabWrapper,
    meta: {
      permissions: ailabRoutePermissions,
      featureFlag: FEATURE_FLAGS.CAPTAIN,
      installationTypes: [
        INSTALLATION_TYPES.CLOUD,
        INSTALLATION_TYPES.ENTERPRISE,
      ],
    },
    children: [
      {
        path: '',
        name: 'ailab_assistants_inboxes_index',
        component: AssistantInboxesIndex,
      },
    ],
  },
  {
    path: frontendURL(
      'accounts/:accountId/ailab/assistants/:assistantId/guardrails'
    ),
    component: AilabWrapper,
    meta: {
      permissions: ailabRoutePermissions,
      featureFlag: FEATURE_FLAGS.CAPTAIN,
      installationTypes: [
        INSTALLATION_TYPES.CLOUD,
        INSTALLATION_TYPES.ENTERPRISE,
      ],
    },
    children: [
      {
        path: '',
        name: 'ailab_assistants_guardrails_index',
        component: AssistantGuardrailsIndex,
      },
    ],
  },
  {
    path: frontendURL(
      'accounts/:accountId/ailab/assistants/:assistantId/scenarios'
    ),
    component: AilabWrapper,
    meta: {
      permissions: ailabRoutePermissions,
      featureFlag: FEATURE_FLAGS.CAPTAIN,
      installationTypes: [
        INSTALLATION_TYPES.CLOUD,
        INSTALLATION_TYPES.ENTERPRISE,
      ],
    },
    children: [
      {
        path: '',
        name: 'ailab_assistants_scenarios_index',
        component: AssistantScenariosIndex,
      },
    ],
  },
  {
    path: frontendURL(
      'accounts/:accountId/ailab/assistants/:assistantId/guidelines'
    ),
    component: AilabWrapper,
    meta: {
      permissions: ailabRoutePermissions,
      featureFlag: FEATURE_FLAGS.CAPTAIN,
      installationTypes: [
        INSTALLATION_TYPES.CLOUD,
        INSTALLATION_TYPES.ENTERPRISE,
      ],
    },
    children: [
      {
        path: '',
        name: 'ailab_assistants_guidelines_index',
        component: AssistantGuidelinesIndex,
      },
    ],
  },
  {
    path: frontendURL('accounts/:accountId/ailab/documents'),
    component: AilabWrapper,
    meta: {
      permissions: ailabRoutePermissions,
      featureFlag: FEATURE_FLAGS.CAPTAIN,
      installationTypes: [
        INSTALLATION_TYPES.CLOUD,
        INSTALLATION_TYPES.ENTERPRISE,
      ],
    },
    children: [
      { path: '', name: 'ailab_documents_index', component: DocumentsIndex },
    ],
  },
  {
    path: frontendURL('accounts/:accountId/ailab/responses'),
    component: AilabWrapper,
    meta: {
      permissions: ailabRoutePermissions,
      featureFlag: FEATURE_FLAGS.CAPTAIN,
      installationTypes: [
        INSTALLATION_TYPES.CLOUD,
        INSTALLATION_TYPES.ENTERPRISE,
      ],
    },
    children: [
      { path: '', name: 'ailab_responses_index', component: ResponsesIndex },
    ],
  },
  {
    path: frontendURL(
      'accounts/:accountId/ailab/assistants/:assistantId/product-info'
    ),
    component: AilabWrapper,
    meta: {
      permissions: ailabRoutePermissions,
      featureFlag: FEATURE_FLAGS.CAPTAIN,
      installationTypes: [
        INSTALLATION_TYPES.CLOUD,
        INSTALLATION_TYPES.ENTERPRISE,
      ],
    },
    children: [
      { path: '', name: 'ailab_product_info', component: ProductInfoIndex },
    ],
  },
  {
    path: frontendURL('accounts/:accountId/ailab/assistants/:assistantId/v2'),
    component: AilabWrapper,
    meta: {
      permissions: ailabRoutePermissions,
      featureFlag: FEATURE_FLAGS.CAPTAIN,
      installationTypes: [
        INSTALLATION_TYPES.CLOUD,
        INSTALLATION_TYPES.ENTERPRISE,
      ],
    },
    children: [
      { path: '', name: 'ailab_assistant_v2', component: AssistantV2Index },
    ],
  },
  // Aliases for Assistant V2 so the left sidebar can highlight AI Closer/AI gamer correctly.
  {
    path: frontendURL('accounts/:accountId/ailab/ai-closer/:assistantId'),
    component: AilabWrapper,
    meta: {
      permissions: ailabRoutePermissions,
      featureFlag: FEATURE_FLAGS.CAPTAIN,
      installationTypes: [
        INSTALLATION_TYPES.CLOUD,
        INSTALLATION_TYPES.ENTERPRISE,
      ],
    },
    children: [
      {
        path: '',
        name: 'ailab_ai_closer_assistant_v2',
        component: AssistantV2Index,
      },
    ],
  },
  {
    path: frontendURL('accounts/:accountId/ailab/ai-gamer/:assistantId'),
    component: AilabWrapper,
    meta: {
      permissions: ailabRoutePermissions,
      featureFlag: FEATURE_FLAGS.CAPTAIN,
      installationTypes: [
        INSTALLATION_TYPES.CLOUD,
        INSTALLATION_TYPES.ENTERPRISE,
      ],
    },
    children: [
      {
        path: '',
        name: 'ailab_ai_gamer_assistant_v2',
        component: AssistantV2Index,
      },
    ],
  },
  {
    path: frontendURL('accounts/:accountId/ailab/ai-closer'),
    component: AilabWrapper,
    meta: {
      permissions: ailabRoutePermissions,
      featureFlag: FEATURE_FLAGS.CAPTAIN,
      installationTypes: [
        INSTALLATION_TYPES.CLOUD,
        INSTALLATION_TYPES.ENTERPRISE,
      ],
    },
    children: [
      { path: '', name: 'ailab_ai_closer_index', component: AICloserIndex },
    ],
  },
  {
    path: frontendURL('accounts/:accountId/ailab/ai-gamer'),
    component: AilabWrapper,
    meta: {
      permissions: ailabRoutePermissions,
      featureFlag: FEATURE_FLAGS.CAPTAIN,
      installationTypes: [
        INSTALLATION_TYPES.CLOUD,
        INSTALLATION_TYPES.ENTERPRISE,
      ],
    },
    children: [
      { path: '', name: 'ailab_ai_gamer_index', component: AIGamerIndex },
    ],
  },
];
